import type { ComboboxItem } from "@mantine/core";
import type { NumericComboboxItem } from "../../components/BuildingBlocks/Forms/MantineFormFields/fields/FormFieldSelect";

type SortableComboboxItem = ComboboxItem | NumericComboboxItem;

/** Sorts Mantine Combobox items alphabetically by label, case-insensitive */
export function sortComboboxItems(
  a: SortableComboboxItem,
  b: SortableComboboxItem
) {
  const displayNameA = a.label.toLowerCase();
  const displayNameB = b.label.toLowerCase();

  if (displayNameA < displayNameB) {
    return -1;
  }

  if (displayNameA > displayNameB) {
    return 1;
  }

  return 0;
}
